<h2 class="text-center">Donation Dashboard</h2>

<section>
  <div class="container-fluid mt-2">
    <div class="row">
      <!-- Card 1: Attempted Donations -->
      <div class="col-lg-3 col-sm-6">
        <div class="info-box7 l-bg-card1 order-info-box7 scale-on-hover">
          <div class="info-box7-block">
            <h4 class="m-b-20">Attempted Donations</h4>
            <h2 class="text-end"><i class="fas fa-hand-holding-heart float-start"></i><span>{{ attemptedDonations || 0 }}</span></h2>
          </div>
        </div>
      </div>

      <!-- Card 2: Total Donation Amount -->
      <div class="col-lg-3 col-sm-6">
        <div class="info-box7 l-bg-card2 order-info-box7 scale-on-hover">
          <div class="info-box7-block">
            <h4 class="m-b-20">Total Donation Amount</h4>
            <h2 class="text-end"><i class="fas fa-donate float-start"></i><span>{{ totalDonationAmount || 0 }}</span></h2>
          </div>
        </div>
      </div>

      <!-- Card 3: Failed Donations -->
      <div class="col-lg-3 col-sm-6">
        <div class="info-box7 l-bg-card3 order-info-box7 scale-on-hover">
          <div class="info-box7-block">
            <h4 class="m-b-20">Failed Donations</h4>
            <h2 class="text-end"><i class="fas fa-times-circle float-start"></i><span>{{ failedDonations || 0 }}</span></h2>
          </div>
        </div>
      </div>

      <!-- Card 4: Successful Donations -->
      <div class="col-lg-3 col-sm-6">
        <div class="info-box7 l-bg-card4 order-info-box7 scale-on-hover">
          <div class="info-box7-block">
            <h4 class="m-b-20">Successful Donations</h4>
            <h2 class="text-end"><i class="fas fa-check-circle float-start"></i><span>{{ successfulDonations || 0 }}</span></h2>
          </div>
        </div>
      </div>

      <!-- Card 5: Custom Campaigns -->
      <div class="col-lg-3 col-sm-6">
        <div class="info-box7 l-bg-card5 order-info-box7 scale-on-hover">
          <div class="info-box7-block">
            <h4 class="m-b-20">Custom Campaigns</h4>
            <h2 class="text-end"><i class="fas fa-bullhorn float-start"></i><span>{{ customCampaigns || 0 }}</span></h2>
          </div>
        </div>
      </div>
    </div>

    <!-- Add graphs and tables as needed -->
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <mat-card class="mat-mdc-card mdc-card">
          <mat-card-header class="mat-mdc-card-header header-style">
            <div class="mat-mdc-card-header-text">
              <mat-card-title class="mat-mdc-card-title">{{ chartTitle }}</mat-card-title>
            </div>
          </mat-card-header>
          <mat-card-content class="mat-mdc-card-content">
            <div id="AreaChart">
              <apx-chart
                [series]="chartOptionsArea.series"
                [chart]="chartOptionsArea.chart"
                [xaxis]="chartOptionsArea.xaxis"
                [yaxis]="chartOptionsArea.yaxis"
                [stroke]="chartOptionsArea.stroke"
                [dataLabels]="chartOptionsArea.dataLabels"
                [colors]="chartOptionsArea.colors"
                [legend]="chartOptionsArea.legend"
                [fill]="chartOptionsArea.fill">
              </apx-chart>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
        <mat-card class="mat-mdc-card mdc-card">
          <mat-card-header class="mat-mdc-card-header header-style">
            <div class="mat-mdc-card-header-text">
              <mat-card-title class="mat-mdc-card-title">Donations</mat-card-title>
            </div>
          </mat-card-header>
          <mat-card-content>
            <div id="donationBarChart">
              <apx-chart
                [series]="donationChartOptions.series"
                [chart]="donationChartOptions.chart"
                [xaxis]="donationChartOptions.xaxis"
                [yaxis]="donationChartOptions.yaxis"
                [dataLabels]="donationChartOptions.dataLabels"
                [stroke]="donationChartOptions.stroke"
                [fill]="donationChartOptions.fill"
                [legend]="donationChartOptions.legend"
                [colors]="donationChartOptions.colors"
                [grid]="donationChartOptions.grid"
                [tooltip]="donationChartOptions.tooltip"
                [plotOptions]="donationChartOptions.plotOptions"
              ></apx-chart>
            </div>
          </mat-card-content>
        </mat-card>
      </div>

    </div>
  </div>
  <div class="mb-4 mt-4">
    <h4 class="mb-3 font-bold">Recent Donation</h4>
    <table mat-table [dataSource]="latestDonors" class="mat-elevation-z2 full-width-table">

      <!-- Donor Name -->
      <ng-container matColumnDef="donated_by">
        <th mat-header-cell *matHeaderCellDef> Donor </th>
        <td mat-cell *matCellDef="let row"> {{ row.donated_by }} </td>
      </ng-container>

      <!-- Email -->
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef> Email </th>
        <td mat-cell *matCellDef="let row"> {{ row.email }} </td>
      </ng-container>

      <!-- Mobile -->
      <ng-container matColumnDef="mobile">
        <th mat-header-cell *matHeaderCellDef> Mobile </th>
        <td mat-cell *matCellDef="let row"> {{ row.mobile }} </td>
      </ng-container>

      <!-- Amount -->
      <ng-container matColumnDef="donation_amount">
        <th mat-header-cell *matHeaderCellDef> Amount </th>
        <td mat-cell *matCellDef="let row"> ₹{{ row.donation_amount }} </td>
      </ng-container>

      <!-- Description -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef> Purpose </th>
        <td
          mat-cell
          *matCellDef="let row"
          matTooltip="{{ row.description }}"
          matTooltipShowDelay="500"
          class="ellipsis-cell"
        >
          {{ row.description }}
        </td>
      </ng-container>


      <!-- Date -->
      <ng-container matColumnDef="createdAt">
        <th mat-header-cell *matHeaderCellDef> Date </th>
        <td mat-cell *matCellDef="let row"> {{ row.createdAt | date:'dd MMM yyyy, h:mm a' }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['donated_by','email','mobile','donation_amount','description','createdAt']"></tr>
      <tr mat-row *matRowDef="let row; columns: ['donated_by','email','mobile','donation_amount','description','createdAt'];"></tr>
    </table>
  </div>
</section>
